"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var TextBox = function TextBox(field, formValues, handleInputChange, classes) {
  var disabled = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  var id = field.id,
    type = field.type,
    required = field.required,
    label = field.label,
    placeHolder = field.placeHolder;
  return /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.formLabel
  }, label, required ? /*#__PURE__*/_react.default.createElement("span", {
    className: classes.required
  }, "*") : null), /*#__PURE__*/_react.default.createElement(_TextField.default, {
    id: id,
    name: id,
    disabled: disabled,
    placeholder: placeHolder,
    type: type,
    required: required,
    variant: "outlined"
    // eslint-disable-next-line react/destructuring-assignment
    ,

    value: formValues[id],
    onChange: handleInputChange
    // error={!checkIsValid(field, formValues)}
    ,

    InputProps: {
      classes: {
        input: classes.inputText
      }
    }
  }));
};
var _default = TextBox;
exports.default = _default;